const NMP_METADATA = {
	'24-hour': {
		title: 'Cheap 24 Hour Storage Near You | SpareFoot',
		description:
			'Discover 24 hour storage options near you. Compare the top nearby facilities, check real-time availability, and unlock competitive prices today!',
	},
	'climate-controlled': {
		title: 'Cheap Climate Controlled Storage Near You | SpareFoot',
		description:
			'Discover climate controlled storage options near you. Compare the top nearby facilities, check real-time availability, and unlock competitive prices today!',
	},
	'drive-up': {
		title: 'Cheap Drive Up Storage Near You | SpareFoot',
		description:
			'Discover drive up storage options near you. Compare the top nearby facilities, check real-time availability, and unlock competitive prices today!',
	},
	electricity: {
		title: 'Cheap Storage With Electricity Near You | SpareFoot',
		description:
			'Discover storage with electricity near you. Compare the top nearby facilities, check real-time availability, and unlock competitive prices today!',
	},
	wine: {
		title: 'Cheap Wine Storage Near You | SpareFoot',
		description:
			'Discover wine storage options near you. Compare the top nearby facilities, check real-time availability, and unlock competitive prices today!',
	},

	mini: {
		title: 'Discover Cheap Mini Storage Near You | SpareFoot',
		description:
			'Find the perfect mini storage near you! Quickly compare prices and availability of local mini storage, and reserve your unit online today!',
	},
	'5x5': {
		title: 'Discover Cheap 5x5 Storage Units Near You | SpareFoot',
		description:
			'Find the perfect 5x5 storage unit near you! Quickly compare prices and availability of local 5x5 storage units, and reserve online today!',
	},
	'5x10': {
		title: 'Discover Cheap 5x10 Storage Units Near You | SpareFoot',
		description:
			'Find the perfect 5x10 storage unit near you! Quickly compare prices and availability of local 5x10 storage units, and reserve online today!',
	},
	'5x15': {
		title: 'Discover Cheap 5x15 Storage Units Near You | SpareFoot',
		description:
			'Find the perfect 5x15 storage unit near you! Quickly compare prices and availability of local 5x15 storage units, and reserve online today!',
	},
	'10x10': {
		title: 'Discover Cheap 10x10 Storage Units Near You | SpareFoot',
		description:
			'Find the perfect 10x10 storage unit near you! Quickly compare prices and availability of local 10x10 storage units, and reserve online today!',
	},
	'10x15': {
		title: 'Discover Cheap 10x15 Storage Units Near You | SpareFoot',
		description:
			'Find the perfect 10x15 storage unit near you! Quickly compare prices and availability of local 10x15 storage units, and reserve online today!',
	},
	'10x20': {
		title: 'Discover Cheap 10x20 Storage Units Near You | SpareFoot',
		description:
			'Find the perfect 10x20 storage unit near you! Quickly compare prices and availability of local 10x20 storage units, and reserve online today!',
	},
	'10x25': {
		title: 'Discover Cheap 10x25 Storage Units Near You | SpareFoot',
		description:
			'Find the perfect 10x25 storage unit near you! Quickly compare prices and availability of local 10x25 storage units, and reserve online today!',
	},
	'10x30': {
		title: 'Discover Cheap 10x30 Storage Units Near You | SpareFoot',
		description:
			'Find the perfect 10x30 storage unit near you! Quickly compare prices and availability of local 10x30 storage units, and reserve online today!',
	},
	locker: {
		title: 'Discover Cheap Storage Lockers Near You | SpareFoot',
		description:
			'Find your perfect storage locker near you! Quickly compare prices and availability of local storage lockers, and reserve your unit online today!',
	},

	boat: {
		title: 'Score Great Deals on Cheap Boat Storage Near You | SpareFoot',
		description:
			'Discover the best-reviewed boat storage near you! Compare prices & availability, and keep your boat close to home. Reserve online in minutes!',
	},
	car: {
		title: 'Score Great Deals on Cheap Car Storage Near You | SpareFoot',
		description:
			'Discover the best-reviewed car storage near you! Compare prices & availability, and keep your car close to home. Reserve online in minutes!',
	},
	rv: {
		title: 'Score Great Deals on Cheap RV Storage Near You | SpareFoot',
		description:
			'Discover the best-reviewed RV storage near you! Compare prices & availability, and keep your RV close to home. Reserve online in minutes!',
	},

	'storage-deals': {
		title: 'Discover The Best Storage Deals Near You | SpareFoot',
		description:
			'Find the best storage deals near you! Quickly compare prices and availability of local storage deals, and reserve your unit online for free!',
	},
	'free-truck-rental': {
		title: 'Cheap Storage With Free Truck Rental Near You | SpareFoot',
		description:
			'Discover great deals on storage with free truck rental near you. Compare the top nearby facilities, check availability, and unlock competitive prices today!',
	},
};

/**
 * Extracts the NMP metadata key from a URL slug.
 * e.g. "climate-controlled-storage" → "climate-controlled"
 *      "storage-with-electricity" → "electricity"
 *      "storage-deals" → "storage-deals"
 *      "rv-storage" → "rv"
 */
export function extractNmpKeyword(slug) {
	if (!slug) return '';
	if (NMP_METADATA[slug]) return slug;
	if (slug.startsWith('storage-with-')) return slug.replace('storage-with-', '');
	if (slug.endsWith('-storage')) return slug.replace(/-storage$/, '');
	return slug;
}

/**
 * Formats a URL keyword slug into a display name for the default template.
 * e.g. "climate-controlled" → "Climate Controlled", "rv" → "RV", "5x5" → "5x5"
 */
function formatKeywordForDisplay(keyword) {
	const uppercaseKeywords = { rv: 'RV', atv: 'ATV' };
	if (uppercaseKeywords[keyword]) {
		return uppercaseKeywords[keyword];
	}
	return keyword.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Returns the NMP title and description for a given URL keyword.
 * Falls back to the default template if no specific entry exists.
 *
 * @param {string} keyword - The URL keyword (e.g., "climate-controlled", "5x5", "rv")
 * @returns {{ title: string, description: string }}
 */
export function getNmpMetadata(keyword) {
	if (NMP_METADATA[keyword]) {
		return NMP_METADATA[keyword];
	}

	const displayName = formatKeywordForDisplay(keyword);
	return {
		title: `Cheap ${displayName} Storage Near You | SpareFoot`,
		description: `Discover great deals on ${displayName.toLowerCase()} storage near you. Compare nearby storage with real prices & availability. Reserve online in minutes!`,
	};
}
